<template lang="pug">
    lairdnd-forgot-password(
        :settings="settings"
        :translations="translations"
    )
</template>

<script>
export default {
    name: 'forgot-password-page',

    data() {
        return {
            settings: {
                showSubmitErrorOnFields: true,
                form: {
                    fields: {
                        email: {
                            show: true,
                        },
                    },
                },
            },

            translations: {
                title: 'Forgot Password?',
                subTitle: 'Enter the email address associated with your account.',
                fields: {
                    email: {
                        label: 'Email address',
                    },
                },
                submitButtonTitle: 'Send',
                successTitle: 'Check Your Email',
                successMessage: 'We have sent a password recovery instruction to your email.'
            },
        }
    },
}
</script>
